module.exports = __webpack_public_path__ + "img/d.2b76c831.png";